import React, { useState } from "react";
import _ from "lodash";

import { SelectItem } from "../SelectItem/SelectItem";
import { ClickAwayListener } from "@material-ui/core";
import { getDropDownItems, truncateString } from "../../../../utils/helpers";
import { useGlobalSearchContext } from "../../../../context/globalSearch.context";

const initState = [
	{
		checked: true,
		value: "All",
		queryParam: null,
		id: 0,
	},
	...getDropDownItems(),
];

export function Select({ toggleExpandBg }) {
	const [isOpen, setIsOpen] = useState(false);
	const { isArabic } = useGlobalSearchContext();

	const [dropdownItems, setDropdownItems] = useState([
		{
			checked: true,
			value: isArabic ? "الكل" : "All",
			queryParam: null,
			id: 0,
		},
		...getDropDownItems(isArabic ? "ar" : "en"),
	]);

	const [selectedValues, setSelectedValues] = useState(null);

	const { handleSetTypes } = useGlobalSearchContext();

	function toggleIsOpen() {
		setIsOpen(!isOpen);
		toggleExpandBg();
	}

	function handleCheckItem(id) {
		return () => {
			const elemAllId = 0;

			let existCheked = false;

			let otherChecked = false;

			let isAllChecked = false;

			let changedItems = _.map(dropdownItems, (item) => {
				if (item.id === id) item.checked = !item.checked;
				if (item.checked) existCheked = true;
				if (item.checked && item.id !== elemAllId) otherChecked = true;
				if (item.checked && item.id === elemAllId) isAllChecked = true;
				return item;
			});

			// Set `All` checked
			if (!existCheked)
				_.find(changedItems, (item) => item.id === elemAllId).checked = true;

			if (otherChecked)
				_.find(changedItems, (item) => item.id === elemAllId).checked = false;

			if (id === elemAllId) {
				changedItems = _.map(changedItems, (item) => {
					if (item.id === elemAllId) item.checked = true;
					else item.checked = false;
					return item;
				});
			}

			setDropdownItems(changedItems);
			// Set query params
			const selectedItems = _.filter(changedItems, (item) => item.checked);

			let selectedQueries = _.map(selectedItems, (item) => item.queryParam);

			if (selectedItems.length === 1 && selectedItems[0].id === elemAllId)
				selectedQueries = null;
			// setQuery(selectedQueries);
			handleSetTypes(selectedQueries);

			setSelectedValues(_.map(selectedItems, (item) => item.value));

			console.log(
				"selected values: ",
				_.map(selectedItems, (item) => item.value)
			);
			//Replace this setQuery with something...

			// console.log(selectedQueries);
		};
	}
	const allLabel = isArabic ? "الكل" : "All";
	return (
		<div className="select">
			<div className="select__top " onClick={toggleIsOpen}>
				<div className="select__value" style={{ color: "#201F57" }}>
					{selectedValues
						? truncateString(selectedValues.join(", "))
						: allLabel}
				</div>
				<div className="select__arrow">
					<svg
						width="14"
						height="9"
						viewBox="0 0 14 9"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M1 1.33331L7.18677 6.66665L13 1.33331"
							stroke="#201F57"
							strokeWidth="2"
						/>
					</svg>
				</div>
			</div>
			{isOpen && (
				<ClickAwayListener onClickAway={toggleIsOpen}>
					<div className="select__dropdown ">
						{dropdownItems.map((item) => (
							<SelectItem
								key={item.value}
								data={item}
								handleCheckItem={handleCheckItem}
							/>
						))}
					</div>
				</ClickAwayListener>
			)}
		</div>
	);
}
